import { useState } from "react";
import useMerchantPortalAxios, {
  useMerchantPortalFormData,
} from "../utils/axios";

const useS2SAPI = () => {
  const MerchantPortalAxios = useMerchantPortalAxios();
  const MerchantPortalAxios1 = useMerchantPortalFormData();
  const [s2sData, setS2sData] = useState([]);
  const [s2sLoading, setS2sLoading] = useState(true);
  const [totalNbOfPage, setTotalNbOfPage] = useState(1);
  const [totalCount, setTotalCount] = useState(1);

  async function GetS2STransfersList(pageNb, dateFrom, dateTo) {
    await MerchantPortalAxios.post(`/v1/S2S/GetS2STransfersList`, {
      SessionID: sessionStorage.getItem("SessionID"),
      page: pageNb,
      pageSize: 10,
      DateFrom: dateFrom,
      DateTo: dateTo,
    }).then((res) => {
      setS2sData(res.data.Payload.SuyoolToSuyoolTransactions);
      if (res.data.Payload.SuyoolToSuyoolTransactions?.length === 0) {
        setTotalNbOfPage(0);
        setTotalCount(0);
      } else {
        setTotalNbOfPage(
          res.data.Payload.SuyoolToSuyoolTransactions[0].TotalPages,
        );
        setTotalCount(
          res.data.Payload.SuyoolToSuyoolTransactions[0].TotalCount || 0,
        );
      }

      if (res.data.Payload.TemplateURL)
        sessionStorage.setItem(
          "S2sTransferTemplate",
          res.data.Payload.TemplateURL,
        );
      setS2sLoading(false);
    });
  }

  const PushS2STransfer = async (payload) => {
    if (payload.ReasonFile) {
      const fileData = payload.ReasonFile.split(",")[1];
      const mimeType = payload.ReasonFile.split(":")[1].split(";")[0];
      const byteCharacters = atob(fileData);
      const byteArrays = new Uint8Array(byteCharacters.length);
      for (let i = 0; i < byteCharacters.length; i++) {
        byteArrays[i] = byteCharacters.charCodeAt(i);
      }
      const file = new File([byteArrays], payload.ReasonFileName, {
        type: mimeType,
      });
      payload.ReasonFile = file;
    }

    const response = await MerchantPortalAxios1.post(
      "/v1/S2S/PushS2STransfer",
      payload,
    );
    return response.data;
  };

  const PushBulkS2STransfer = async (payload) => {
    if (payload.formFile) {
      const fileData = payload.formFile.split(",")[1];
      const mimeType = payload.formFile.split(":")[1].split(";")[0];
      const byteCharacters = atob(fileData);
      const byteArrays = new Uint8Array(byteCharacters.length);
      for (let i = 0; i < byteCharacters.length; i++) {
        byteArrays[i] = byteCharacters.charCodeAt(i);
      }
      const file = new File([byteArrays], payload.ReasonFileName, {
        type: mimeType,
      });
      payload.formFile = file;
    }
    const { ReasonFileName, ...newPayload } = payload;

    const response = await MerchantPortalAxios1.post(
      "/v1/S2S/PushBulkS2STransfer",
      newPayload,
    );
    return response.data;
  };

  const GetSuggestedCorporateNames = async (name) => {
    const response = await MerchantPortalAxios.post(
      "/v1/S2S/GetSuggestedCorporateNames",
      {
        SessionID: sessionStorage.getItem("SessionID"),
        Name: name,
      },
    );
    return response.data;
  };

  const GetS2STransferConfig = async () => {
    const response = await MerchantPortalAxios.post(
      "/v1/S2S/GetS2STransferConfig",
      {
        SessionID: sessionStorage.getItem("SessionID"),
      },
    );
    return response.data;
  };
  const GetS2STransferSuggestions = async (InputText,typeId) => {
    const response = await MerchantPortalAxios.post(
      "/v1/S2S/GetS2STransferSuggestions",
      {
        SessionID: sessionStorage.getItem("SessionID"),
        InputText: InputText,
        AccountTypeId: typeId,
      },
    );
    return response.data;
  };

  return {
    GetS2STransfersList,
    PushS2STransfer,
    PushBulkS2STransfer,
    GetSuggestedCorporateNames,
    GetS2STransferConfig,
    GetS2STransferSuggestions,
    s2sData,
    s2sLoading,
    totalNbOfPage,
    totalCount,
  };
};
export default useS2SAPI;
